import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { defineCustomElements as scope } from '@myscania/scope/dist/loader';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { defineCustomElements as myScaniaChat } from '@myscania/myscania-chat-widget/loader';

if (environment.production) {
  enableProdMode();
}

platformBrowser()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch((err) => console.error(err));

scope();
myScaniaChat();
